import { Lead } from '../types/lead'
import {
  calculateLeadScore,
  calculateEvidenceCompleteness,
} from '../utils/scoring'

const baseLeads: Partial<Lead>[] = [
  {
    id: 'L-001',
    NOMBRE_NEGOCIO: 'Casa Pepe',
    DECISOR_NOMBRE: 'José Martínez',
    DECISOR_CARGO: 'Propietario',
    TELEFONO_WHATSAPP: '+34600123456',
    VERIFICADO: true,
    DIRECCION: {
      calle: 'Calle Mayor',
      numero: '12',
      barrio: 'Centro',
      ciudad: 'Madrid',
    },
    TAG_GEO: 'MAD-Centro',
    ESTADO_WEB_MENU: 'No web',
    MENU_STATUS: 'Papel',
    NOTA_CARENCIA: 'Menú sucio, sin presencia online',
    LEAD_SOURCE: 'GMB',
    ENRICHMENT_READY: true,
    OWNER_ID: 'U-001',
    STATE: 'Nuevo',
    CREATED_AT: '2026-05-01T10:00:00Z',
    UPDATED_AT: '2026-05-01T10:00:00Z',
    RRSS_HANDLES: {},
    EVIDENCE_ATTACHMENTS: [],
    hasPropietarioVisible: true,
    hasBuenVolumenResenas: false,
  },
  {
    id: 'L-002',
    NOMBRE_NEGOCIO: 'La Tasquita de Enfrente',
    DECISOR_NOMBRE: 'María Gómez',
    DECISOR_CARGO: 'Gerente',
    TELEFONO_WHATSAPP: '+34611223344',
    VERIFICADO: true,
    DIRECCION: {
      calle: 'Carrer de Blai',
      numero: '45',
      barrio: 'Poble Sec',
      ciudad: 'Barcelona',
    },
    TAG_GEO: 'BCN-PobleSec',
    ESTADO_WEB_MENU: 'Web obsoleta',
    MENU_STATUS: 'PDF',
    NOTA_CARENCIA: 'Web flash no carga en móvil',
    LEAD_SOURCE: 'IG',
    ENRICHMENT_READY: true,
    OWNER_ID: 'U-001',
    STATE: 'Contactado',
    LAST_CONTACT: '2026-05-08T15:30:00Z',
    NEXT_ACTION_DATE: '2026-05-10T10:00:00Z',
    CREATED_AT: '2026-05-02T11:00:00Z',
    UPDATED_AT: '2026-05-08T15:30:00Z',
    RRSS_HANDLES: { instagram: '@latasquitabcn' },
    EVIDENCE_ATTACHMENTS: [],
    hasPropietarioVisible: false,
    hasBuenVolumenResenas: true,
  },
  {
    id: 'L-003',
    NOMBRE_NEGOCIO: 'Bar Manolo',
    DECISOR_NOMBRE: 'Manuel Ruiz',
    DECISOR_CARGO: 'Dueño',
    TELEFONO_WHATSAPP: '+34622334455',
    VERIFICADO: false,
    DIRECCION: {
      calle: 'Avenida de la Constitución',
      numero: '8',
      barrio: 'Casco Antiguo',
      ciudad: 'Sevilla',
    },
    TAG_GEO: 'SEV-Centro',
    ESTADO_WEB_MENU: 'No web',
    MENU_STATUS: 'Papel',
    NOTA_CARENCIA: 'Solo boca a boca',
    LEAD_SOURCE: 'Directorio',
    ENRICHMENT_READY: true,
    OWNER_ID: 'U-002',
    STATE: 'Conversación',
    LAST_CONTACT: '2026-05-09T09:15:00Z',
    NEXT_ACTION_DATE: '2026-05-11T16:00:00Z',
    CREATED_AT: '2026-05-03T09:00:00Z',
    UPDATED_AT: '2026-05-09T09:15:00Z',
    RRSS_HANDLES: {},
    EVIDENCE_ATTACHMENTS: [],
    hasPropietarioVisible: true,
    hasBuenVolumenResenas: true,
  },
  {
    id: 'L-004',
    NOMBRE_NEGOCIO: 'El Rincón Andaluz',
    DECISOR_NOMBRE: 'Carmen López',
    DECISOR_CARGO: 'Propietaria',
    TELEFONO_WHATSAPP: '+34633445566',
    VERIFICADO: true,
    DIRECCION: {
      calle: 'Calle Ruzafa',
      numero: '22',
      barrio: 'Ruzafa',
      ciudad: 'Valencia',
    },
    TAG_GEO: 'VAL-Ruzafa',
    ESTADO_WEB_MENU: 'Web funcional',
    MENU_STATUS: 'Digital',
    NOTA_CARENCIA: 'Web ok pero menú difícil de actualizar',
    LEAD_SOURCE: 'Referral',
    ENRICHMENT_READY: true,
    OWNER_ID: 'U-001',
    STATE: 'Micro-acuerdo',
    MICRO_ACCION_TYPE: 'Propuesta',
    MICRO_ACCION_DATE: '2026-05-12T12:00:00Z',
    CANAL_CONFIRMACION: 'WhatsApp',
    TEXTO_EVIDENCIA: 'Vale, envíame esa propuesta de 1 página a ver qué tal.',
    LAST_CONTACT: '2026-05-09T14:20:00Z',
    NEXT_ACTION_DATE: '2026-05-12T12:00:00Z',
    CREATED_AT: '2026-05-04T14:00:00Z',
    UPDATED_AT: '2026-05-09T14:20:00Z',
    RRSS_HANDLES: { facebook: 'rinconandaluzval' },
    EVIDENCE_ATTACHMENTS: [
      {
        id: 'att-1',
        url: '#',
        filename: 'wa_screenshot.jpg',
        type: 'image/jpeg',
      },
    ],
    hasPropietarioVisible: true,
    hasBuenVolumenResenas: true,
  },
  {
    id: 'L-005',
    NOMBRE_NEGOCIO: 'Pizzeria Bella Roma',
    DECISOR_NOMBRE: 'Alessandro Rossi',
    DECISOR_CARGO: 'Gerente',
    TELEFONO_WHATSAPP: '+34644556677',
    VERIFICADO: true,
    DIRECCION: {
      calle: 'Gran Vía',
      numero: '50',
      barrio: 'Abando',
      ciudad: 'Bilbao',
    },
    TAG_GEO: 'BIL-Abando',
    ESTADO_WEB_MENU: 'Web obsoleta',
    MENU_STATUS: 'PDF',
    NOTA_CARENCIA: 'PDF pesa 10MB, no carga en 4G',
    LEAD_SOURCE: 'GMB',
    ENRICHMENT_READY: true,
    OWNER_ID: 'U-002',
    STATE: 'LeadCualificado',
    MICRO_ACCION_TYPE: 'Demo',
    MICRO_ACCION_DATE: '2026-05-10T18:00:00Z',
    CANAL_CONFIRMACION: 'WhatsApp',
    TEXTO_EVIDENCIA: 'Sí, me interesa ver la demo mañana a las 18h.',
    LAST_CONTACT: '2026-05-09T11:00:00Z',
    NEXT_ACTION_DATE: '2026-05-10T18:00:00Z',
    CREATED_AT: '2026-05-05T16:00:00Z',
    UPDATED_AT: '2026-05-09T11:00:00Z',
    RRSS_HANDLES: { instagram: '@bellaromabilbao' },
    EVIDENCE_ATTACHMENTS: [
      { id: 'att-2', url: '#', filename: 'consent.png', type: 'image/png' },
    ],
    hasPropietarioVisible: false,
    hasBuenVolumenResenas: true,
  },
]

export const mockLeads: Lead[] = baseLeads.map((lead) => {
  const { score, icpPriority } = calculateLeadScore(lead)
  const completeness = calculateEvidenceCompleteness(lead)
  return {
    ...lead,
    LEAD_SCORE: score,
    ICP_PRIORITY: icpPriority,
    EVIDENCE_COMPLETENESS: completeness,
  } as Lead
})
